import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { useTranslation as e } from "../../../hooks/useTranslation/index.js";
import { useDropdownContext as l } from "../../../contexts/Dropdown/context.js";
import { NotificationBarHeaderContainer as c, NotificationBarTitle as f, NotificationBarBackButton as m, NotificationBarBellIcon as d, NotificationBarReadAllButton as u } from "./style.js";
import { ArrowLeft as B, Bell as b } from "@pelando/fontawesome/icons";
function w({
  onBackClick: i,
  onReadAllClick: n
}) {
  const { t } = e("common"), { closeDropdown: a } = l();
  return /* @__PURE__ */ r(c, { children: [
    /* @__PURE__ */ r(f, { children: [
      /* @__PURE__ */ o(
        m,
        {
          role: "button",
          "aria-label": t("go-to-back-button-aria-label"),
          icon: B,
          onClick: () => {
            a(), i && i();
          }
        }
      ),
      /* @__PURE__ */ o("h2", { children: t("notification-bar-title") }),
      /* @__PURE__ */ o(d, { role: "img", icon: b })
    ] }),
    /* @__PURE__ */ o(u, { role: "button", onClick: n, children: t("notification-bar-read-all-button") })
  ] });
}
export {
  w as NotificationBarHeader
};
